import type { LogDescriptor } from '../log/client';

/** Lower-case, ASCII letters/digits only, dashes between: "IPng Networks" → "ipng-networks". */
export function slugify(s: string): string {
  return s
    .normalize('NFKD')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Short name of a log: strip the operator prefix and quotes from "Google 'Argon2026h2' log". */
export function shortLogName(l: LogDescriptor): string {
  const op = l.operator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return l.description.replace(new RegExp(`^${op}\\s*'?`, 'i'), '').replace(/'?\s*(log)?$/i, '').replace(/^'|'$/g, '') || l.description;
}

export function operatorSlug(operator: string): string {
  return slugify(operator) || 'custom';
}

/** The log's own path segment before collision handling. */
export function logSlug(l: LogDescriptor): string {
  return slugify(shortLogName(l)) || slugify(l.description) || 'log';
}
